import React, { type FC } from 'react';
import { ReactComponent as SunIcon } from '../../icons/sun-setting.svg';
import { ReactComponent as AlertTriangleIcon } from '../../icons/alert-triangle-outline.svg';
import { ReactComponent as MailIcon } from '../../icons/mail-05.svg';
import { ReactComponent as TrayIcon } from '../../icons/inbox-01.svg';

export const ArrowLeftIcon: FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    aria-hidden='true'
  >
    <path
      d='M13.33 8H2.67M2.67 8L8 13.33M2.67 8L8 2.67'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const ChevronDownIcon: FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    aria-hidden='true'
  >
    <path
      d='m4 6 4 4 4-4'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const ChevronRightIcon: FC = () => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    aria-hidden='true'
  >
    <path
      d='m5 3 4 4-4 4'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const SparkleIcon: FC = () => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    aria-hidden='true'
  >
    <path
      d='m7 1 1.06 3.94L12 6l-3.94 1.06L7 11 5.94 7.06 2 6l3.94-1.06L7 1Z'
      fill='currentColor'
    />
  </svg>
);

export const CheckIcon: FC = () => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    aria-hidden='true'
  >
    <path
      d='m3 7.5 2.5 2.5L12 3.5'
      stroke='currentColor'
      strokeWidth='1.8'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const ChatIcon: FC = () => (
  <svg
    width='17'
    height='17'
    viewBox='0 0 17 17'
    fill='none'
    aria-hidden='true'
  >
    <path
      d='M3 3.5h11v7H8l-3.5 3v-3H3v-7Z'
      stroke='currentColor'
      strokeWidth='1.4'
      strokeLinejoin='round'
    />
  </svg>
);

export const RotateIcon: FC = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    aria-hidden='true'
  >
    <path
      d='M3 6.5A5 5 0 0 1 12 4l1.5 1.5M13 9.5A5 5 0 0 1 4 12L2.5 10.5'
      stroke='currentColor'
      strokeWidth='1.4'
      strokeLinecap='round'
    />
    <path
      d='M13.5 3.5v2h-2M2.5 12.5v-2h2'
      stroke='currentColor'
      strokeWidth='1.4'
    />
  </svg>
);

export const MinusCircleIcon: FC = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    aria-hidden='true'
  >
    <circle cx='12' cy='12' r='9' stroke='currentColor' strokeWidth='1.5' />
    <path
      d='M8 12h8'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
  </svg>
);

export const JobIcon: FC<{ index: number }> = ({ index }) => {
  const icon = index % 4;
  if (icon === 0) return <SunIcon aria-hidden='true' />;
  if (icon === 1) return <AlertTriangleIcon aria-hidden='true' />;
  if (icon === 2) return <MailIcon aria-hidden='true' />;
  return <TrayIcon aria-hidden='true' />;
};
